import type { Point } from '../../hex/types';

/**
 * Paper-grain speckle fill for tiles. Caller should clip before drawing.
 */
export function speckle(
    ctx: CanvasRenderingContext2D,
    rng: () => number,
    verts: Point[],
    zoom: number,
    alpha = 0.05,
): void {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const v of verts) {
        minX = Math.min(minX, v.x);
        minY = Math.min(minY, v.y);
        maxX = Math.max(maxX, v.x);
        maxY = Math.max(maxY, v.y);
    }

    const area = (maxX - minX) * (maxY - minY);
    const n = Math.floor((area / 1800) * (1.2 + 0.6 * rng()) * Math.max(0.75, Math.min(1.4, zoom)));
    ctx.fillStyle = `rgba(0,0,0,${alpha})`;

    const rMin = 0.5 / zoom;
    const rMax = 1.2 / zoom;

    for (let i = 0; i < n; i += 1) {
        const x = minX + (maxX - minX) * rng();
        const y = minY + (maxY - minY) * rng();
        const rad = rMin + (rMax - rMin) * rng();
        ctx.beginPath();
        ctx.arc(x, y, rad, 0, Math.PI * 2);
        ctx.fill();
    }
}
